import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { LookupService } from 'src/app/services/lookup.service';
import { UserService } from 'src/app/components/user-profile/user.service';
import _ from 'lodash';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GeneralFormComponent } from 'src/app/shared/components/general-form/general-form.component';
import { forkJoin } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';
import { Helper } from 'src/app/shared/utils/helper';
import { AddressBookModalComponent } from 'src/app/shared/components/address-book-modal/address-book-modal.component';
import { ChangePwdComponent } from './change-pwd/change-pwd.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent extends GeneralFormComponent implements OnInit {
  countryList = [];
  counter = 0;
  isEdit: boolean = false;
  myStation: boolean = true;
  isFromEditable: boolean = true;

  bsmodalRef: BsModalRef;
  constructor(
    private fb: FormBuilder,
    private lookupService: LookupService,
    private userService: UserService,
    private toaster:ToastrService,
    private modalService: BsModalService
  ) {
    super();
  }

  ngOnInit() {
    this.createForm();
    this.loadData();
  }

  createForm() {
    this.mform = this.fb.group({
      name: [null, [Validators.required]],
      email: [null ],
      mobile: [null, [Validators.required]],
      address1: [null, [Validators.required]],
      address2: [null],
      city: [null, [Validators.required]],
      postCode: [null, [Validators.required]],
      state: [null ],
      country: ["MY", [Validators.required]],
      isPrivate: [true, [Validators.required]],
      isDefaultShipper: [true, [Validators.required]],
      id: [null]
    });
  }



  private loadData() {
    this.lookupService.countryList().pipe(
      tap((res: any) => this.countryList = res.items),
      switchMap((res) => this.loadMe()),
    ).subscribe()
  }

  loadMe() {
    return this.lookupService.getDefaultAddress().pipe(
      tap((res:any)=>this.bindAddress(res.result))
    )
  }

  private bindAddress(data) {
    if (data==null) {
      return
    }
    
    this.mform.patchValue(
      {
        id: data.id,
        isPrivate:data.isPrivate,
        name: data.name,
        email: data.email,
        mobile: data.mobile,
        address1: data.address1,
        address2: data.address2,
        postCode: data.postCode,
        city: data.city,
        isDefaultShipper:data.isDefaultShipper,
        state: data.state,
        country: data.country,
        latitude: data.latitude,
        longitude: data.longitude
      }
    )
  }
  private bindAddressByLookUp(data) {    
    this.mform.patchValue(
      {
        id: data.id,
        isPrivate:data.isPrivate,
        name: data.name,
        address1: data.address1,
        address2: data.address2,
        postCode: data.postCode,
        country: data.country,
        isDefaultShipper: data.isDefaultShipper,
        city: data.city,
        state: data.state,
        mobile: data.mobile,
        email: data.email,
      }
    )
  }

  changeCoountry(data){
    this.updatePostcodeValidation();
  }

  onSubmit() {
    const data = this.mform.getRawValue();
    if (this.mform.invalid) {
      return this.mform.markAllAsTouched();
    }

    this.updatePostcodeValidation();

    if (this.mform.get("id").value==null) {
      return this.createDefaultAddress(data)
    }

    this.userService.setDefaultAddress(data)
    .pipe(
      tap((res)=>this.toaster.success("Successfully updated"))
    )
    .subscribe()
  }

  createDefaultAddress(data){
    this.userService.createDefaultAddress(data)
    .pipe(
      tap((res)=>console.log(res)),
      tap((res)=>this.toaster.success("Successfully created"))
    )
    .subscribe()
  }

  getAddressByPostcode() {
    const postcode = this.mform.get("postCode").value;
    if (Helper.isEmpty(postcode)) {
      return;
    }
    this.updatePostcodeValidation();
    const country = this.mform.get("country").value;
    this.lookupService.getAddressByPostcode(postcode, country)
      .pipe(
        tap((res: any) => this.bindAddressByPostcode(res.result))
      )
      .subscribe()
  }

  bindAddressByPostcode(data) {
    if (!data) {
      return
    }
    this.mform.patchValue(
      {
        country: data.country,
        state: data.state,
        city: data.city
      }
    )
  }

  private updatePostcodeValidation(){   
    const country = this.mform.get("country").value;
    const pattern = Helper.getPostcodePatterns(country);   
    this.mform.get('postCode').setValidators([Validators.required, Validators.pattern(pattern)]);
    this.mform.get('postCode').updateValueAndValidity();
    this.mform.get('postCode').markAsTouched();
  }

  onChangeBusinessId() {}

  changePassword() {
    this.bsmodalRef = this.modalService.show(ChangePwdComponent, { class: 'modal-xl' });
  }

  addressByLookUp() {
    this.bsmodalRef = this.modalService.show(AddressBookModalComponent, { class: 'modal-xl' });
    this.bsmodalRef.content.onClose
      .pipe(
        tap((res: any) => this.bindAddressByLookUp(res.data))
      )
      .subscribe()
  }
}
